import { render, staticRenderFns } from "./AdminCate.vue?vue&type=template&id=3543d35a&"
import script from "./AdminCate.vue?vue&type=script&lang=js&"
export * from "./AdminCate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports